// export class ClassScroll {
//   constructor() {
//     this.triggerPagetop = document.getElementById("js-scroll-trigger-pagetop");
//     this.excutePagetop();
//   }
//   excutePagetop = () => {
//     const observer = new IntersectionObserver(
//       (entries) => {
//         const entry = entries[0];
//         if (!entry.isIntersecting) {
//           // 200px以上スクロール時
//           document.body.classList.add("is-scroll-pagetop");
//           // console.log('200pxスクロール → ON');
//         } else {
//           // 200pxより上に戻った時
//           document.body.classList.remove("is-scroll-pagetop");
//           // console.log('200px戻る → OFF');
//         }
//       },
//       {
//         rootMargin: "0px 0px 0px 0px",
//         threshold: 0,
//       },
//     );

//     observer.observe(this.triggerPagetop);
//   };
// }
export class ClassScroll {
  constructor() {
    this.triggerPagetop = document.getElementById("js-scroll-trigger-pagetop");
    this.scrollTimer = null;

    this.initPagetopObserver();
    this.initScrollState();
  }

  /* =========================
    ① 表示条件（200px以上）
  ========================= */
  initPagetopObserver() {
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];

        if (!entry.isIntersecting) {
          // 200px以上スクロール → 表示OK状態
          document.body.classList.add("is-scroll-pagetop");
        } else {
          // 上に戻った
          document.body.classList.remove("is-scroll-pagetop");
        }
      },
      {
        threshold: 0,
      }
    );

    observer.observe(this.triggerPagetop);
  }

  /* =========================
    ② スクロール中判定（軽量）
  ========================= */
  initScrollState() {
    window.addEventListener(
      "scroll",
      () => {
        document.body.classList.remove("is-scrolling-stop");
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => {
          document.body.classList.add("is-scrolling-stop");
          // console.log("scrollstop")
        }, 150);
      },
      { passive: true }
    );
  }
}

